import { sendCallback } from "./sendCallback.js";
import { createCallbackAppElement } from "./createCallback.js";

export function appCallbackEntmerken(matnr) {
    sendCallback(createCallbackAppElement(false, matnr));
}
